<template>
  <div>
    <!-- 选择支付的校园卡 -->
    <van-action-sheet v-model="isShow" title="支付方式">
      <van-radio-group class="play-class" v-model="queryParams.payType" @change="change">
        <van-radio
                :class="{'paylist': queryParams.payType === item.value}"
                v-for="(item, index) in payTypeList"
                :key="index"
                :name="item.value">{{item.label}}
        </van-radio>
      </van-radio-group>

      <!--校园卡-->
      <div v-if="queryParams.payType === '0'">
        <campus-card ref="campusCard" selectable @change="cardChange"/>
        <div class="card-list">
          <ul>
            <li v-for="(item, index) in selectCards" :key="index">
              <b>卡号: {{item.cardNo}}</b>
              <span>余额: {{item.cardBalance}}</span>
            </li>
          </ul>
        </div>
      </div>

      <!--校内转账支付-->
      <div v-if="queryParams.payType === '2'">
        <!--<van-field-->
        <!--        readonly-->
        <!--        clickable-->
        <!--        name="picker"-->
        <!--        :value="queryParams.inventoryTypeName"-->
        <!--        label="结算清单"-->
        <!--        placeholder="请选择"-->
        <!--        @click="showPicker = true"-->
        <!--/>-->
        <!--<van-popup v-model="showPicker" position="bottom">-->
        <!--  <van-picker value-key="label" show-toolbar :columns="inventoryTypeList" @confirm="pickerConfirm"-->
        <!--              @cancel="showPicker = false"/>-->
        <!--</van-popup>-->
        <van-field :value="getDictName(this.inventoryTypeList, this.record.inventoryType)" label="结算清单" disabled/>
        <van-field :value="today" label="结算日期" disabled/>
        <van-field v-model="queryParams.inventoryName" label="使用人" placeholder="请输入"/>
        <van-field v-model="queryParams.inventoryUnit" label="使用单位" placeholder="请输入"/>
        <!--<van-field-->
        <!--        readonly-->
        <!--        clickable-->
        <!--        name="calendar"-->
        <!--        :value="queryParams.inventoryDate"-->
        <!--        label="结算日期"-->
        <!--        placeholder="请选择"-->
        <!--        @click="showCalendar = true"-->
        <!--/>-->
        <van-calendar color="#2C68E4" v-model="showCalendar" @confirm="calendarConfirm" :minDate="minDate"/>
      </div>

      <div class="b-but">
        <button @click="pay()" :disabled="loading" :loading="loading">确认</button>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  import moment from 'moment'
  import CampusCard from '@/views/components/CampusCard'
  import {Dialog} from "vant";
  import {pay, platformWxPay} from "@/api/order/order";
  import {getDictByType} from '@/api/common'
  import {getDictName} from '@/utils/common'
  import {getUserInfo} from "@/api/my/my"

  export default {
    name: 'CampusCardPayment',
    components: {
      // eslint-disable-next-line vue/no-unused-components
      CampusCard
    },
    data() {
      return {
        record: {},
        getDictName,
        today: moment().format('YYYY-MM-DD'),
        loading: false,
        minDate: moment().add(-1, 'month').toDate(),
        isShow: false,
        totalAmount: 0,
        queryParams: {},
        selectCards: {},
        payTypeList: [],
        inventoryTypeList: [],
        showPicker: false,
        showCalendar: false,
        userInfo: {}
      }
    },
    computed: {
      getInventoryType () {
        return getDictName(this.inventoryTypeList, this.record.inventoryType)
      }
    },
    created() {
      getUserInfo().then(res => {
        if (res.code === 10000) {
          this.userInfo = res.result
        }
      })
      getDictByType('pay_type').then(res => {
        if (res.result) {
          this.payTypeList = res.result.map(item => {
            return {label: item.dictKey, value: item.dictValue}
          })
        }
      })
      getDictByType('inventory_type').then(res => {
        if (res.result) {
          this.inventoryTypeList = res.result.map(item => {
            return {label: `${item.dictKey}结算清单`, value: item.dictValue}
          })
        }
      })
    },
    mounted() {
    },
    methods: {
      change(e) {
       if (e == 2) {
         this.queryParams.inventoryName = this.userInfo.fullName
         this.queryParams.inventoryUnit = this.userInfo.topOrganizeName
         this.$forceUpdate()
       }
      },
      show(res) {
        this.record = res
        this.totalAmount = res.totalAmount || 0
        this.queryParams.id = res.id
        this.isShow = true
      },

      pay() {
        if (!this.queryParams.payType) {
          this.$toast("请选择支付方式")
          return
        }
        if (this.queryParams.payType === '0') {
          if (this.selectCards.length === 0) {
            this.$toast("请选择校园卡")
            return
          }
          this.queryParams.cardNos = this.selectCards.map(i => i.cardNo)
        }
        if (this.queryParams.payType === '2') {
          if (!this.queryParams.inventoryType && !this.queryParams.inventoryName && !this.queryParams.inventoryUnit && !this.queryParams.inventoryDate) {
            this.$toast("请填写完整信息")
            return
          }
        }
        Dialog.confirm({
          message: '是否支付',
        }).then(() => {
          if (this.queryParams.payType === '1' && this.totalAmount > 0) {
            this.loading = true
            platformWxPay(this.queryParams).then(res => {
              console.log(res)
            }).catch(e => {
              console.error(e)
              this.loading = false
            })
          } else {
            this.loading = true
            pay(this.queryParams).then(res => {
              if (res.code === 10000) {
                this.$toast("支付成功")
                this.$parent.refresh()
                this.isShow = false
              } else {
                this.loading = false
              }
            }).catch(e => {
              console.error(e)
              this.loading = false
            })
          }
        })
      },
      cardChange(list) {
        this.selectCards = list
        this.$forceUpdate()
      },
      pickerConfirm(data) {
        this.queryParams.inventoryType = data.value
        this.queryParams.inventoryTypeName = data.label
        this.showPicker = false
        this.$forceUpdate()
      },
      calendarConfirm(data) {
        this.queryParams.inventoryDate = moment(data).format("YYYY-MM-DD")
        this.showCalendar = false
        this.$forceUpdate()
      }
    }
  }
</script>

<style scoped>
  .play-class {
    display: flex;
    padding: 20px 10px;
    align-items: center;
    justify-content: center;
  }

  /deep/ .van-radio {
    border: 1px solid #dedede;
    flex: 1;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    border-radius: 3px;
  }
  .paylist{
    border: 1px solid #2C68E4 !important;
  }
  .card-list {
    padding: 0 10px;
  }
/deep/.van-cell{
  padding: 0 20px;
  height: 44px;
}
/deep/.van-cell::after{
  border-bottom: none;
}

/deep/.van-field__label{
  width:70px;
  height: 34px;
  display: flex;
  align-items: center;
}
/deep/.van-field__body{
  border: 1px solid #dedede;
  border-radius: 3px;
  height:34px;
  padding: 0 10px;
}
  .card-list ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #efefef;
  }

  .card-list ul li b {
    font-size: 14px;
  }

  .card-list ul li span {
    font-size: 14px;
    font-weight: bold;
    color: #ff6600;
  }

  /deep/ .carbox {
    max-height: 50vh;
    overflow-y: auto;
  }
</style>
